// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2Khu1","label":"Labeled_label__2hSV2","divider":"Labeled_divider__37Aqp"};